export default "__VITE_ASSET__DYQ6Awq$__"